// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-4793358d]{display:none}.block-image-list[data-v-4793358d]{margin-bottom:32px}.wrapper__items[data-v-4793358d]{display:flex;flex-direction:column;gap:16px}.wrapper__title[data-v-4793358d]{color:var(--c-black-primary);letter-spacing:-.5px;margin-bottom:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
